import { render, staticRenderFns } from "./ViewCredentialCardModal.vue?vue&type=template&id=fecac04c"
import script from "./ViewCredentialCardModal.vue?vue&type=script&lang=js"
export * from "./ViewCredentialCardModal.vue?vue&type=script&lang=js"
import style0 from "./ViewCredentialCardModal.vue?vue&type=style&index=0&id=fecac04c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports